// @ts-nocheck
import { Plugin } from '/Users/jiangyichen/Desktop/work/FE-src/third-link_web/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
